import { addLocaleData } from 'react-intl';
import he from 'react-intl/locale-data/he';
import en from 'react-intl/locale-data/en';
import fr from 'react-intl/locale-data/fr';
import de from 'react-intl/locale-data/de';
import it from 'react-intl/locale-data/it';
import ru from 'react-intl/locale-data/ru';
import pl from 'react-intl/locale-data/pl';
import es from 'react-intl/locale-data/es';
import ko from 'react-intl/locale-data/ko';
import id from 'react-intl/locale-data/id';

import LocalizedDayjs from 'common/localized_dayjs';

let loaded = false;
const configureLocales = function(locale) {
  if (!loaded) {
    // If you are adding a new locale, please check localized_dayjs and add
    // the locale to that as well.
    // TODO awallace: look for a way to sync this with localized_dayjs
    addLocaleData([
      ...en,
      ...he,
      ...fr,
      ...de,
      ...it,
      ...ru,
      ...pl,
      ...es,
      ...ko,
      ...id,
    ]);
    loaded = true;
  }
  LocalizedDayjs.locale(locale);
};

export { configureLocales };
